import {
    inputClassName,
    searchableListClassName,
    searchBarClassName,
    virtualListClassName,
    checkboxClassName,
    virtualListItemSlotClassNames,
    pxToRem,
    searchableListSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const FilterSearchList: StyleRule<{
    emptyList: boolean;
    hideSearch?: boolean;
}> = ({ emptyList, hideSearch }) => ({
    display: 'flex',
    flexDirection: 'column',

    [`& .${searchableListClassName}`]: {
        [`& .${searchBarClassName}`]: {
            [`& .${inputClassName}`]: {
                paddingLeft: 0,
            },
        },
        ...(hideSearch && {
            [`& .${searchableListSlotClassNames.input}`]: {
                display: 'none',
            },
            [`& .${searchableListSlotClassNames.options}`]: {
                marginTop: 0,
            },
        }),

        [`& .${virtualListClassName}`]: {
            display: emptyList ? 'none' : 'unset',
            [`& .${virtualListItemSlotClassNames.contentContainer}`]: {
                paddingRight: pxToRem(8),
            },
            [`& .${checkboxClassName}`]: {
                height: 'auto',
            },
        },
    },
});
